import React from "react";
import "../styles/Terms.css";

const TermsOfService = () => {
  return (
    <div data-theme="dark">

      {/* NAVBAR */}
      <nav className="legal-nav">
        <a href="/" className="legal-nav-back">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M9 2L4 7L9 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          RETURN TO VEGAS KARTS
        </a>
        <button
          className="legal-print-btn"
          onClick={() => window.print()}
        >
          ⎙ PRINT / SAVE PDF
        </button>
      </nav>

      {/* MAIN CONTENT */}
      <main className="legal-container">
        <div className="draft-notice">
          ⚠ DRAFT — REVIEW WITH LICENSED ATTORNEY BEFORE PUBLICATION OR USE. This document is a template only and does not constitute legal advice.
        </div>

        <header className="tos-hero">
          <div className="tos-hero-bg" aria-hidden="true">
            <div className="tos-hero-lines" />
            <div className="tos-hero-glow" />
          </div>
          <div className="tos-eyebrow">// LEGAL DOCUMENTATION</div>
          <h1 className="tos-title">
            TERMS OF<br /><span className="tos-title-accent">SERVICE</span>
          </h1>
          <div className="tos-meta-row">
            <span className="tos-meta-chip">Vegas Karts LLC</span>
            <span className="tos-meta-chip">Effective: March 2026</span>
            <span className="tos-meta-chip">Las Vegas, NV</span>
            <a href="mailto:sales@vegaskarts.com" className="tos-meta-chip link">sales@vegaskarts.com</a>
          </div>
        </header>

        <h2><span className="section-num">§1 </span>Acceptance of Terms</h2>
        <p>By accessing or using <strong>vegaskarts.com</strong> (the "Site"), purchasing a pre-order reservation, or registering a driver profile, you agree to be bound by these Terms of Service ("Terms"). If you do not agree, do not use the Site or purchase any service. These Terms apply to all visitors, users, and purchasers.</p>

        <h2><span className="section-num">§2 </span>Service Description</h2>
        <p>Vegas Karts LLC ("Vegas Karts," "we," "us," or "our") operates a street-legal go-kart touring experience in Las Vegas, Nevada. Participants drive open-wheel, mid-engine kit cars (DF Goblin platform) on public streets under supervision. The experience is scheduled for <strong>Winter 2026 deployment</strong> and is subject to regulatory approval, vehicle certification, and operational readiness.</p>
        <p>All purchases made on this Site prior to the Winter 2026 launch are <strong>pre-order reservations only</strong> — not confirmed bookings with a specific date or time. Scheduling will be communicated after service launch.</p>

        <h2><span className="section-num">§3 </span>Pre-Order Terms</h2>
        <div className="tos-callout">
          <div className="tos-callout-label">PRE-ORDER NOTICE</div>
          <p>Pre-orders are reservations for future service. They do not guarantee a specific date, time, or tour slot. Vegas Karts will contact pre-order holders via the email address provided to schedule their experience following Winter 2026 deployment.</p>
        </div>
        <p><strong>Refund Policy:</strong> Full refunds are available upon request within <strong>30 days</strong> of purchase. No refund is available after a specific session has been scheduled and confirmed. To request a refund, contact <a href="mailto:sales@vegaskarts.com">sales@vegaskarts.com</a> with your order confirmation.</p>
        <p><strong>Service Availability:</strong> We reserve the right to modify, delay, or cancel service delivery due to regulatory, operational, or safety requirements. In the event of cancellation, pre-order holders will receive a full refund.</p>

        <h2><span className="section-num">§4 </span>Driver Profiles &amp; Registration</h2>
        <p>Registering a "driver profile" (callsign + email) on this Site creates a newsletter subscription only. No financial data is collected or stored in connection with newsletter registration. Your registration is not a purchase or binding contract.</p>

        <h2><span className="section-num">§5 </span>Payments</h2>
        <p>All payments are processed by <strong>Stripe, Inc.</strong> Vegas Karts does not collect, store, or have access to payment card information. Stripe's terms of service and privacy policy apply to all payment transactions. By completing a purchase, you agree to Stripe's terms available at stripe.com.</p>

        <h2><span className="section-num">§6 </span>Age &amp; License Requirements</h2>
        <p>Participation in the Vegas Karts experience requires: (a) a minimum age of <strong>18 years</strong>; and (b) a <strong>valid, unexpired driver's license</strong> from any U.S. state or country that is valid for operation in Nevada. You must present your driver's license at the time of experience. Failure to meet these requirements will result in forfeiture of your reservation without refund.</p>

        <h2><span className="section-num">§7 </span>Prohibited Conduct</h2>
        <p>You agree not to: </p>
        <ul className="tos-list">
          <li>Operate a Vegas Karts vehicle while impaired by alcohol, narcotics, prescription medication, or any substance that impairs driving ability</li>
          <li>Engage in reckless or dangerous driving behaviors</li>
          <li>Use the experience for any illegal activity</li>
          <li>Tamper with vehicles or equipment</li>
          <li>Attempt to operate outside of designated routes or without supervision</li>
        </ul>
        <p>Violations will result in <strong>immediate removal from the experience without refund.</strong></p>

        <h2><span className="section-num">§8 </span>Intellectual Property</h2>
        <p>All content on this Site, including but not limited to the Vegas Karts brand name, logo, vehicle imagery, mission names, and generated graphics, is the proprietary property of Vegas Karts LLC. Unauthorized reproduction or use is prohibited.</p>

        <h2><span className="section-num">§9 </span>User-Generated Content &amp; Social Sharing</h2>
        <p>By sharing mission cards, tagging @vegaskarts on social media, or otherwise sharing content referencing Vegas Karts, you grant Vegas Karts LLC a non-exclusive, royalty-free, worldwide license to use, reproduce, and display such content for marketing and promotional purposes. We will credit you where reasonably practicable.</p>

        <h2><span className="section-num">§10 </span>Privacy</h2>
        <p><strong>Data collected:</strong> Email address and optional name (for newsletter registration and purchase processing). We do not sell or share your personal information with third parties except as required to fulfill your order (Stripe) or as required by law.</p>
        <p><strong>Analytics:</strong> This Site uses Google Analytics 4 to collect anonymized usage data including page views and interactions. No personally identifiable information is passed to Google Analytics.</p>
        <p id="privacy"><strong>Communications:</strong> By registering a driver profile or making a purchase, you consent to receiving transactional and marketing emails from Vegas Karts LLC related to your reservation and the Vegas Karts experience. You may unsubscribe at any time.</p>

        <h2><span className="section-num">§11 </span>Limitation of Liability</h2>
        <div className="tos-warning-block">
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, VEGAS KARTS LLC SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THIS SITE OR THE VEGAS KARTS SERVICE. IN NO EVENT SHALL OUR TOTAL LIABILITY TO YOU EXCEED THE AMOUNT YOU PAID TO US IN THE 12 MONTHS PRECEDING THE CLAIM. PARTICIPATION IN THE VEGAS KARTS EXPERIENCE INVOLVES INHERENT RISKS INCLUDING PERSONAL INJURY OR DEATH. SEE SEPARATE LIABILITY WAIVER FOR FULL DETAILS.
        </div>

        <h2><span className="section-num">§12 </span>Governing Law</h2>
        <p>These Terms are governed by the laws of the <strong>State of Nevada</strong>. Any disputes shall be resolved in the state or federal courts located in <strong>Clark County, Nevada</strong>. You consent to personal jurisdiction in such courts.</p>

        <h2><span className="section-num">§13 </span>Changes to Terms</h2>
        <p>We may update these Terms at any time. Updated Terms will be posted at this URL with a new effective date. Continued use of the Site following any update constitutes your acceptance of the revised Terms.</p>

        <section id="s14" className="tos-section">
          <h2><span className="section-num">§14 </span>Contact</h2>
          <div className="tos-contact-card">
            <div className="tos-contact-corner tos-contact-tl" />
            <div className="tos-contact-corner tos-contact-br" />
            <div className="tos-contact-name">Vegas Karts LLC</div>
            <div className="tos-contact-loc">📍 Las Vegas, Nevada</div>
            <a href="mailto:sales@vegaskarts.com" className="tos-contact-email">sales@vegaskarts.com</a>
          </div>
        </section>

      </main>

      {/* FOOTER */}
      <footer className="tos-footer">
        <div className="tos-footer-line" />
        <div className="tos-footer-inner">
          <span>© 2026 Vegas Karts LLC · All rights reserved</span>
          <div className="tos-footer-links">
            <a href="/waiver">Liability Waiver</a>
            <span className="tos-footer-dot">·</span>
            <a href="https://www.perplexity.ai/computer" target="_blank" rel="noopener">Created with Perplexity Computer</a>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default TermsOfService;